import { Helmet } from "react-helmet-async"
import { CreateHotel } from "../../../Hotels"
import { useNavigate } from "../../../router-utils"

export default function NewHotel() {
	const navigate = useNavigate()
	return (
		<>
			<Helmet>
				<title>Add Hotel</title>
			</Helmet>
			<CreateHotel
				onSuccess={(hotel) =>
					navigate("/hotels/:hotelId", {
						params: { hotelId: hotel.id.toString() },
					})
				}
				onCancel={() => navigate("/org/hotels")}
			/>
		</>
	)
}
